import axios from "axios";

export default {
  namespaced: true,
  state: {
    contents: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    contentsMessage: ''
  },
  mutations: {
    CLEAR_MARKETCONTENTS(state) {
      state.contents = [];
    },
    RECEIVED_MARKETCONTENTS(state, payload) {
      state.contents = payload;
      state.isReceiving = false;
    },
    RECEIVING_MARKETCONTENTS(state) {
      state.isReceiving = true;
    },
    RECEIVED_MARKETCONTENT(state, payload) {
      state = Object.assign(state, {
        contents: [...state.contents, payload],
        isReceiving: false,
      })
    },
    RECEIVING_MARKETCONTENT(state) {
      state.isReceiving = true;
    },
    UPDATED_MARKETCONTENT(state, payload) {
      let index = state.contents.findIndex(content => content._id === payload._id);
      state = Object.assign(state, {
        contents: state.contents.map((content, i) => {
          if (i === index) {
            return Object.assign({}, content, payload);
          }
          return content;
        }),
        isUpdating: false,
        contentsMessage: 'MarketContents has been updating!',
      })
    },
    UPDATING_MARKETCONTENT(state) {
      state.isUpdating = true;
    },
    DELETED_MARKETCONTENT(state, payload) {
      console.log(payload._id);
      let indexToDelete = state.contents.findIndex(content => content._id === payload._id);
      console.log(indexToDelete);
      let contents = [...state.contents];
      contents.splice(indexToDelete, 1);
      state = Object.assign(state, {
        contents: [...contents],
        isDeleting: false,
        idToDelete: null,
        contentsMessage: 'MarketContent has been Deleted!',
      });
    },
    DELETING_MARKETCONTENT(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteMarketContentRequest({dispatch}, payload) {
      dispatch("deletingMarketContent", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/marketcontent/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "delete", url: url, headers: headers})
      .then(response=>{
        console.log(response.data);
        dispatch("deleteMarketContent", response.data);
      })
      .catch(error=>{
        console.log(error.data);
      });
    },
    async deleteProjectContentRequest({dispatch}, payload) {
      try{
        dispatch("deletingMarketContent", payload);
        let token = localStorage.getItem("token");
        let url ="https://api.tradexc.com:3000/delete/marketcontent/" + payload._id;
        let headers = {"Content-Type": "application/json",Authorization: "Bearer " + token,};
  
        let response = await axios({ method: "delete", url: url, headers: headers });
        dispatch("deleteMarketContent", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertMarketContentRequest({dispatch}, payload) {
      dispatch("receivingMarketContents");
      var token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/insert/marketcontent';
      let data = payload;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      
      let response = await axios({method: "post", url: url, headers: headers, data: data});
      dispatch("receiveMarketContent", response.data);
      return response.data;
    },
    async insertProjectContentRequest({dispatch}, payload) {
      try{
        console.log(payload);
        dispatch("receivingMarketContent");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/insert/marketcontent/' + payload.projectid;
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertProjectContentWithImageRequest({dispatch}, payload) {
      try{
        dispatch("receivingMarketContent");
        let token = localStorage.getItem('token');
        let url = 'https://api.tradexc.com:3000/insert/marketcontent/withimage/' + payload.projectid;
        let data = new FormData();
        let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
  
        data.append('file', payload.imagefile, payload.imagename); 
        delete payload['imagefile'];
        for (let x in payload) data.append(x, payload[x]);
        
        let response = await axios({method: "post", url: url, headers: headers , data: data});
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async getMarketContentsRequest({dispatch}) {
      dispatch("receivingMarketContents");
      let token = localStorage.getItem('token');
      console.log(token)
      let url = 'https://api.tradexc.com:3000/get/marketcontents';
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url, headers: header})
      .then(response => {
        console.log(response.data);
        dispatch("receiveMarketContents", response.data);
      })
    },
    async getMarketContentQueryRequest({dispatch}, payload) {
      try{
        dispatch("receivingMarketContents");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/get/contents/byquery';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("receiveMarketContents", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateMarketContentRequest({dispatch}, payload) {
      dispatch("updatingMarketContent");
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/marketcontent/' + id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method: "put", url: url, headers: headers, data: payload})
      .then((response)=> {
        dispatch("updateMarketContent", response.data);
      })
      .catch((error) => {
        this.alertmessage = error.response.data.error;
      });
    },
    async updateProjectContentRequest({dispatch}, payload) {
      try{
        dispatch("updatingMarketContent");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/marketcontent/' + payload.contentid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("updateMarketContent", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateMarketContentApproveRequest({dispatch}, payload) {
      try{
        dispatch("updatingMarketContent");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/marketcontent/approve/' + payload.contentid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("updateMarketContent", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateMarketContentPendingRequest({dispatch}, payload) {
      try{
        dispatch("updatingMarketContent");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/marketcontent/pending/' + payload.contentid;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        dispatch("updateMarketContent", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateProjectContentWithImageRequest({dispatch}, payload) {
      try{
        dispatch("updatingMarketContent");
        let token = localStorage.getItem('token');
        let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/marketcontent/withimage/' + payload.contentid;

        let data = new FormData();  
        data.append('file', payload.imagefile, payload.imagename); 
        delete payload['imagefile'];
        for (let x in payload) data.append(x, payload[x]);

        let response = await axios({method: "PUT", url: url, headers: headers, data: data});
        dispatch("updateMarketContent", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async updateMarketContentImageRequest({dispatch}, payload) {
      dispatch("updatingMarketContent");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];
      let url = 'https://api.tradexc.com:3000/update/marketcontent/image/' + id;
      let data = new FormData();
      data.append('file', payload.imagefile, payload.imagename); 
      delete payload['imagefile'];
      for (let x in payload) data.append(x, payload[x])
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      return axios({method: "PUT", url: url, headers: headers, data: data})
      .then(response=>{
        dispatch("updateMarketContent", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    clearMarketContents({commit}) {
      commit("CLEAR_MARKETCONTENTS")
    },
    receiveMarketContents({commit}, payload) {
      commit("RECEIVED_MARKETCONTENTS", payload)
    },
    receivingMarketContents({commit}) {
      commit("RECEIVING_MARKETCONTENTS")
    },
    receiveMarketContent({commit}, payload) {
      commit("RECEIVED_MARKETCONTENT", payload)
    },
    receivingMarketContent({commit}) {
      commit("RECEIVING_MARKETCONTENT")
    },
    updateMarketContent({commit}, payload) {
      commit("UPDATED_MARKETCONTENT", payload)
    },
    updatingMarketContent({commit}) {
      commit("UPDATING_MARKETCONTENT")
    },
    deleteMarketContent({commit}, payload) {
      commit("DELETED_MARKETCONTENT", payload)
    },
    deletingMarketContent({commit}, payload) {
      commit("DELETING_MARKETCONTENT", payload)
    }
  },
};
